  let customBuyButtons = document.querySelectorAll(".buy-option-label input[name='purchase_type']");
  let simpleVariantContainer = document.querySelector(".simple-variant");
  let subscriptionVariantContainer = document.querySelector(".subscription-variant");
  let productGridWrapper = document.querySelector(".product-icon-grid-main-wrapper");
  let percentMax = document.querySelectorAll(".max-percentage-subscription");
  let percentContainer = document.querySelector(".main-percentage-container");
  let percentContainerValue = document.querySelector(".main-percentage-container .percentage-value");
  let customBuyBtn = document.querySelector(".custom-buy-btn .buybtn-custom-price");
  
  
  
  // if (percentMax.length > 1) {
  //   let percentValueMax = percentMax[1].getAttribute("maxvalue");
  //   percentContainerValue.innerHTML = percentValueMax;
  //   percentContainer.classList.remove("hidden")
  // }
  
  if (customBuyButtons.length > 0) {
    console.log("YEs Value____________________________________")
  function updateVariantDisplay() {
    // Update quantity - target specifically in product form, not cart drawer
    const qtyBuyWrapper = document.querySelector('.qty-buy-main-wrapper');
    const quantityInput = qtyBuyWrapper ? qtyBuyWrapper.querySelector('.quantity__input') : null;
    if (quantityInput) {
      quantityInput.value = 1;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Reset virtual variant to first selected when variant display changes
    // Unselect all virtual variants first
    document.querySelectorAll('.phi--virtual-variant').forEach(vv => {
      vv.classList.remove('phi--virtual-variant-selected');
      const radio = vv.querySelector('.custom-radio');
      if (radio) {
        radio.style.border = '';
        radio.style.backgroundColor = '';
      }
    });
    
    // Clear all stored virtual variant selections
    document.querySelectorAll('.phi--virtual-variant-hidden').forEach(container => {
      container.dataset.selectedVirtualIndex = '';
    });
    
    // After a short delay, find the currently selected variant and select its first virtual variant
    setTimeout(function() {
      const selectedInput = document.querySelector('.input-label input[type="radio"]:checked');
      if (selectedInput) {
        const variantContainer = selectedInput.closest('.input-label');
        const hasVirtualVariants = variantContainer && variantContainer.dataset.hasVirtualVariants === 'true';
        const variantId = variantContainer && variantContainer.dataset.variantId;
        
        if (hasVirtualVariants && variantId) {
          // Find the first virtual variant for this variant
          const firstVirtualVariant = document.querySelector(`.phi--virtual-variant[data-variant-id="${variantId}"]`);
          if (firstVirtualVariant) {
            // Select the first virtual variant
            selectVirtualVariant(firstVirtualVariant, true, true);
          }
        }
      }
    }, 100);
    
    customBuyButtons.forEach((option, index) => {
      if (option.checked) {
        if (index === 0) {
          productGridWrapper && productGridWrapper.classList.add("hidden")
          // console.log("First option selected (Simple Variant)");
          simpleVariantContainer.classList.remove("hidden");
          subscriptionVariantContainer.classList.add("hidden");
          let buttonPillInputs = document.querySelectorAll(".simple-variant .product-form__input--pill input");
            if (buttonPillInputs.length > 0) {
              buttonPillInputs[0].click();
            }
          
          let buttonPillInputsSimple = document.querySelectorAll(".simple-variant .product-form__input--pill .input-label");
            if (buttonPillInputsSimple.length > 0) {
              let buttonInputXero = buttonPillInputsSimple[0];
              let simplePrice = buttonInputXero.querySelector(".variant-price-normal").getAttribute("normalPrice")
              customBuyBtn.innerHTML = simplePrice ;
              
            }
          
          let productForm = document.querySelector(".product-form form");
          if (productForm) {
            productForm.removeAttribute("data-current-selling-plan-id");
            let sellingPlanInput = productForm.querySelector("input[data-bsub-selling-plan-id-input]");
            if (sellingPlanInput) sellingPlanInput.remove();
          }

        } else if (index === 1) {
          productGridWrapper && productGridWrapper.classList.remove("hidden")
          simpleVariantContainer.classList.add("hidden");
          subscriptionVariantContainer.classList.remove("hidden");
          // Find the first pi-selling-plan-option in subscription variant container
          let firstSellingPlanOption = subscriptionVariantContainer.querySelector(".pi-selling-plan-option");
          let sellingPlanId = "";
          
          if (firstSellingPlanOption) {
            // Get the selling plan ID from the label
            sellingPlanId = firstSellingPlanOption.getAttribute("selling-plan-id");
            
            // Find the radio input within the first selling plan option
            let firstSellingPlanInput = firstSellingPlanOption.querySelector('input[type="radio"]');
            
            if (firstSellingPlanInput) {
              // Check the radio input to make it active
              firstSellingPlanInput.checked = true;
              firstSellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Also trigger click on the label to ensure all handlers fire
              firstSellingPlanOption.click();
            }
            
            // Get prices from the first selling plan option
            let basicSimplePrice = firstSellingPlanOption.querySelector(".variant-price-normal");
            let basicDiscountPrice = firstSellingPlanOption.querySelector(".variant-price-discount");

            let simplePrice = basicSimplePrice && basicSimplePrice.getAttribute("normalPrice");
            let discountPrice = basicDiscountPrice && basicDiscountPrice.getAttribute("discountPrice");

            if (simplePrice && discountPrice) {
              customBuyBtn.innerHTML = simplePrice + " " + discountPrice;
            } else if (simplePrice) {
              customBuyBtn.innerHTML = simplePrice;
            }
          }
    
          // Set up event listeners for all selling plan options
          let allSellingPlanOptions = subscriptionVariantContainer.querySelectorAll(".pi-selling-plan-option");
          allSellingPlanOptions.forEach(option => {
            option.addEventListener("click", function() {
              // Uncheck all other options
              allSellingPlanOptions.forEach(opt => {
                let optInput = opt.querySelector("input[type='radio']");
                if (optInput) {
                  optInput.checked = false;
                }
              });
              
              // Check the clicked option
              let optionInput = this.querySelector("input[type='radio']");
              if (optionInput) {
                optionInput.checked = true;
                optionInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
              // Keep hidden selling_plan input in sync so add-to-cart sends correct plan
              let planId = this.getAttribute("selling-plan-id");
              if (planId) {
                let productForm = document.querySelector(".product-form form");
                let sellingPlanInput = productForm && productForm.querySelector("input[data-bsub-selling-plan-id-input]");
                if (productForm) {
                  productForm.dataset.currentSellingPlanId = planId;
                  if (!sellingPlanInput) {
                    sellingPlanInput = document.createElement("input");
                    sellingPlanInput.type = "hidden";
                    sellingPlanInput.name = "selling_plan";
                    sellingPlanInput.setAttribute("data-bsub-selling-plan-id-input", "");
                    productForm.appendChild(sellingPlanInput);
                  }
                  sellingPlanInput.value = planId;
                }
              }
            });
          });
  
          let productForm = document.querySelector(".product-form form");
          if (productForm && sellingPlanId) {
            let sellingPlanInput = productForm.querySelector("input[data-bsub-selling-plan-id-input]");
            if (!sellingPlanInput) {
              sellingPlanInput = document.createElement("input");
              sellingPlanInput.type = "hidden";
              sellingPlanInput.name = "selling_plan";
              sellingPlanInput.setAttribute("data-bsub-selling-plan-id-input", "");
              productForm.appendChild(sellingPlanInput);
            }
            sellingPlanInput.value = sellingPlanId;
            productForm.dataset.currentSellingPlanId = sellingPlanId;
          }
        }
      }
    });
  }
  
  if (customBuyButtons.length > 0) {
    updateVariantDisplay(); 
  }
  
  customBuyButtons.forEach(option => {
    option.addEventListener("change", updateVariantDisplay);
  });
  
  }

  else{

    // these Code For For Only Variant Not Subscription functionality
    console.log("No Value____________________________________")
    
    function logCheckedInputs() {
      document.querySelectorAll('.simple-variant .input-label').forEach(label => {
        const input = label.querySelector('input');
        if (input && input.checked) {
          let normalPrice = label.querySelector(".variant-price-normal");
          let priceAttr = normalPrice && normalPrice.getAttribute("normalprice");
          customBuyBtn.innerHTML = priceAttr ;
          
        }
      });
    }
    
    // Pehli dafa execute karna
    logCheckedInputs();
    
    // Har input par event listener lagana
    document.querySelectorAll('.simple-variant .input-label input').forEach(input => {
        input.addEventListener('change', logCheckedInputs);
      });
  }

  // Function to get selected variant data from JSON
  function getSelectedVariantData() {
    try {
      const variantSelects = document.querySelector('variant-selects [data-selected-variant]');
      if (variantSelects && variantSelects.textContent) {
        return JSON.parse(variantSelects.textContent);
      }
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
    return null;
  }
  
  // Function to parse price string to number (handles formats like "€197.00", "$10.00", "10.00")
  function parsePrice(priceString) {
    if (!priceString) return 0;
    // Remove currency symbols, spaces, and keep only numbers and decimal point
    const cleaned = priceString.toString().replace(/[^\d.,]/g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  // Function to format price with currency symbol (preserves original format)
  function formatPrice(price, originalPriceString) {
    if (!originalPriceString) {
      return price.toFixed(2);
    }
    
    // Extract currency symbol from original string
    const currencyMatch = originalPriceString.match(/^([^\d.,\s]+)/);
    const currencySymbol = currencyMatch ? currencyMatch[1] : '';
    
    // Format number with 2 decimal places
    const formattedNumber = price.toFixed(2);
    
    return currencySymbol + formattedNumber;
  }
  
  // Function to update buy button price (total = price × quantity)
  // function updateBuyButtonPrice() {
  //   if (!customBuyBtn) return;
    
  //   // Target quantity input specifically in product form, not cart drawer
  //   const qtyBuyWrapper = document.querySelector('.qty-buy-main-wrapper');
  //   const quantityInput = qtyBuyWrapper ? qtyBuyWrapper.querySelector('.quantity__input') : null;
  //   const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
  //   // Check if a virtual variant is selected
  //   const selectedVirtualVariant = document.querySelector('.phi--virtual-variant.phi--virtual-variant-selected');
    
  //   // Check if it's subscription variant
  //   const isSubscription = subscriptionVariantContainer && !subscriptionVariantContainer.classList.contains('hidden');
    
  //   let priceText = '';
  //   let priceValue = 0;
  //   let normalPriceText = '';
  //   let normalPriceValue = 0;
    
  //   if (selectedVirtualVariant) {
  //     // Virtual variant is selected - get price from virtual variant
  //     const priceElement = selectedVirtualVariant.querySelector('.variant-price-normal[normalPrice]');
  //     if (priceElement) {
  //       priceText = priceElement.getAttribute('normalPrice');
  //       priceValue = parsePrice(priceText);
        
  //       // Check for compare price
  //       const comparePriceElement = selectedVirtualVariant.querySelector('.compare-price .glc-money');
  //       if (comparePriceElement) {
  //         normalPriceText = comparePriceElement.textContent.trim();
  //         normalPriceValue = parsePrice(normalPriceText);
  //       }
  //     }
  //   } else {
  //     // Regular variant selected - try to get from variant data first
  //     const variantData = getSelectedVariantData();
      
  //     if (variantData && variantData.price) {
  //       // Use variant price from JSON (in cents, convert to dollars/euros)
  //       priceValue = variantData.price / 100;
  //       // Get formatted price from DOM to preserve currency symbol
  //       const selectedVariantInput = document.querySelector('.input-label input[type="radio"]:checked');
  //       if (selectedVariantInput) {
  //         const variantContainer = selectedVariantInput.closest('.input-label');
  //         const normalPriceElement = variantContainer.querySelector('.variant-price-normal[normalPrice]');
  //         if (normalPriceElement) {
  //           priceText = normalPriceElement.getAttribute('normalPrice');
  //         }
          
  //         if (isSubscription) {
  //           const discountPriceElement = variantContainer.querySelector('.variant-price-discount[discountPrice]');
  //           if (discountPriceElement && discountPriceElement.getAttribute('discountPrice')) {
  //             priceText = discountPriceElement.getAttribute('discountPrice');
  //             priceValue = parsePrice(priceText);
  //             normalPriceText = normalPriceElement ? normalPriceElement.getAttribute('normalPrice') : '';
  //             normalPriceValue = parsePrice(normalPriceText);
  //           }
  //         }
  //       }
  //     } else {
  //       // Fallback to DOM parsing
  //       const selectedVariantInput = document.querySelector('.input-label input[type="radio"]:checked');
  //       if (selectedVariantInput) {
  //         const variantContainer = selectedVariantInput.closest('.input-label');
          
  //         if (isSubscription) {
  //           // Subscription variant - use discount price if available, else normal price
  //           const discountPriceElement = variantContainer.querySelector('.variant-price-discount[discountPrice]');
  //           const normalPriceElement = variantContainer.querySelector('.variant-price-normal[normalPrice]');
            
  //           if (discountPriceElement && discountPriceElement.getAttribute('discountPrice')) {
  //             priceText = discountPriceElement.getAttribute('discountPrice');
  //             normalPriceText = normalPriceElement ? normalPriceElement.getAttribute('normalPrice') : '';
  //             priceValue = parsePrice(priceText);
  //             normalPriceValue = parsePrice(normalPriceText);
  //           } else if (normalPriceElement) {
  //             priceText = normalPriceElement.getAttribute('normalPrice');
  //             priceValue = parsePrice(priceText);
  //           }
  //         } else {
  //           // Simple variant - use normal price
  //           const normalPriceElement = variantContainer.querySelector('.variant-price-normal[normalPrice]');
  //           if (normalPriceElement) {
  //             priceText = normalPriceElement.getAttribute('normalPrice');
  //             priceValue = parsePrice(priceText);
  //           }
  //         }
  //       }
  //     }
  //   }
    
  //   // Calculate total price (price × quantity)
  //   if (priceValue > 0) {
  //     const totalPrice = priceValue * quantity;
      
  //     if (quantity > 1) {
  //       // Show total when quantity > 1
  //       if (isSubscription && normalPriceValue > priceValue) {
  //         // Subscription with discount - show both prices
  //         const totalNormalPrice = normalPriceValue * quantity;
  //         customBuyBtn.innerHTML = formatPrice(totalNormalPrice, normalPriceText) + ' ' + formatPrice(totalPrice, priceText);
  //       } else {
  //         // Just show total
  //         customBuyBtn.innerHTML = formatPrice(totalPrice, priceText || '€');
  //       }
  //     } else {
  //       // Quantity is 1, show single price
  //       if (isSubscription && normalPriceValue > priceValue) {
  //         // Subscription with discount - show both prices
  //         customBuyBtn.innerHTML = normalPriceText + ' ' + priceText;
  //       } else {
  //         // Just show single price
  //         customBuyBtn.innerHTML = priceText || formatPrice(priceValue, '€');
  //       }
  //     }
  //   }
  // }
  
  // Virtual Variant Functionality
  function selectVirtualVariant(virtualVariant, skipVariantChange = false, preventRerender = false) {
    const quantity = parseInt(virtualVariant.dataset.quantity) || 1;
    const variantId = virtualVariant.dataset.variantId;
    const virtualIndex = virtualVariant.dataset.virtualIndex;
    
    // Remove selected state from all virtual variants
    document.querySelectorAll('.phi--virtual-variant').forEach(vv => {
      vv.classList.remove('phi--virtual-variant-selected');
      const radio = vv.querySelector('.custom-radio');
      if (radio) {
        radio.style.border = '';
        radio.style.backgroundColor = '';
      }
    });
    
    // Add selected state to clicked virtual variant
    virtualVariant.classList.add('phi--virtual-variant-selected');
    const radio = virtualVariant.querySelector('.custom-radio');
    if (radio) {
      radio.style.border = '4px solid #fff';
      radio.style.backgroundColor = '#85B0A2';
    }
    
    // Update quantity so correct qty is added to cart
    setProductFormQuantity(quantity);
    
    // Update buy button price
    // setTimeout(updateBuyButtonPrice, 50);
    
    // Store selected virtual variant index in the actual variant container
    const actualVariantContainer = document.querySelector(`.phi--virtual-variant-hidden[data-variant-id="${variantId}"]`);
    if (actualVariantContainer) {
      actualVariantContainer.dataset.selectedVirtualIndex = virtualIndex;
    }
    
    // Ensure the actual variant input is checked
    const actualVariantInput = document.querySelector(`.phi--virtual-variant-hidden[data-variant-id="${variantId}"] input[type="radio"]`);
    if (actualVariantInput) {
      // Always ensure it's checked
      if (!actualVariantInput.checked) {
        actualVariantInput.checked = true;
      }
      
      // Only trigger change event if we're not preventing rerender (i.e., when switching variants)
      // When clicking virtual variant of same variant, don't trigger rerender
      if (!skipVariantChange && !preventRerender) {
        // Set flag to prevent infinite loop
        isProgrammaticChange = true;
        // Use a small timeout to avoid conflicts with other event handlers
        setTimeout(function() {
          // Trigger change event to update URL (this will cause rerender)
          actualVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, 10);
      }
    }
  }
  
  function unselectAllVirtualVariants(resetQuantityToOne = true) {
    document.querySelectorAll('.phi--virtual-variant').forEach(vv => {
      vv.classList.remove('phi--virtual-variant-selected');
      const radio = vv.querySelector('.custom-radio');
      if (radio) {
        radio.style.border = '';
        radio.style.backgroundColor = '';
      }
    });
    
    // Clear all stored virtual variant selections
    document.querySelectorAll('.phi--virtual-variant-hidden').forEach(container => {
      container.dataset.selectedVirtualIndex = '';
    });
    
    // Reset quantity to 1 only when requested - target specifically in product form, not cart drawer
    if (resetQuantityToOne) {
      setProductFormQuantity(1);
    }
  }
  
  // Set quantity input in product form (so correct qty is added to cart per variant)
  function setProductFormQuantity(quantity) {
    const qty = parseInt(quantity, 10) || 1;
    const qtyBuyWrapper = document.querySelector('.qty-buy-main-wrapper');
    let quantityInput = qtyBuyWrapper ? qtyBuyWrapper.querySelector('.quantity__input') : null;
    if (!quantityInput) {
      const productForm = document.querySelector('.product-form form, form[action*="/cart/add"]');
      if (productForm) {
        quantityInput = productForm.querySelector('input[name="quantity"], .quantity__input');
      }
    }
    if (!quantityInput) {
      quantityInput = document.querySelector('.quantity__input');
    }
    if (quantityInput && qty > 0) {
      quantityInput.value = qty;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  
  // Use event delegation to avoid duplicate listeners
  let virtualVariantsInitialized = false;
  let isProgrammaticChange = false;
  
  function initVirtualVariants() {
    if (virtualVariantsInitialized) return;
    
    // Use event delegation for virtual variant clicks
    document.addEventListener('click', function(e) {
      const virtualVariant = e.target.closest('.phi--virtual-variant');
      if (virtualVariant) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = virtualVariant.dataset.variantId;
        const actualVariantInput = document.querySelector(`.phi--virtual-variant-hidden[data-variant-id="${variantId}"] input[type="radio"]`);
        
        // Check if this virtual variant belongs to the currently selected variant
        const isCurrentVariant = actualVariantInput && actualVariantInput.checked;
        
        // If clicking virtual variant of currently selected variant, prevent rerender
        // Only update quantity and store selection
        if (isCurrentVariant) {
          selectVirtualVariant(virtualVariant, false, true); // preventRerender = true
        } else {
          // If clicking virtual variant of different variant, allow rerender
          selectVirtualVariant(virtualVariant, false, false); // preventRerender = false
        }
      }
    });
    
    // Listen for quantity changes - only in product form, not cart drawer
    document.addEventListener('change', function(e) {
      if (e.target.classList && e.target.classList.contains('quantity__input')) {
        // Check if the quantity input is within the product form wrapper
        const qtyBuyWrapper = document.querySelector('.qty-buy-main-wrapper');
        if (qtyBuyWrapper && qtyBuyWrapper.contains(e.target)) {
          // Quantity changed in product form, update buy button price
          // setTimeout(updateBuyButtonPrice, 50);
        }
      }
    });
    
    // Use event delegation for variant input changes
    document.addEventListener('change', function(e) {
      // Skip if this is a programmatic change to avoid infinite loops
      if (isProgrammaticChange) {
        isProgrammaticChange = false;
        return;
      }
      
      if (e.target.type === 'radio' && e.target.checked) {
        const variantContainer = e.target.closest('.input-label');
        if (variantContainer) {
          const hasVirtualVariants = variantContainer.dataset.hasVirtualVariants === 'true';
          const variantId = variantContainer.dataset.variantId;
          
          if (hasVirtualVariants && variantId) {
            // Variant has virtual variants, check if there's a stored selection
            setTimeout(function() {
              const variantContainer = document.querySelector(`.phi--virtual-variant-hidden[data-variant-id="${variantId}"]`);
              const storedVirtualIndex = variantContainer ? variantContainer.dataset.selectedVirtualIndex : null;
              
              let virtualVariantToSelect = null;
              
              if (storedVirtualIndex !== null && storedVirtualIndex !== '') {
                // Restore previously selected virtual variant
                virtualVariantToSelect = document.querySelector(`.phi--virtual-variant[data-variant-id="${variantId}"][data-virtual-index="${storedVirtualIndex}"]`);
              }
              
              // If no stored selection or stored variant not found, select first one
              if (!virtualVariantToSelect) {
                virtualVariantToSelect = document.querySelector(`.phi--virtual-variant[data-variant-id="${variantId}"]`);
              }
              
              if (virtualVariantToSelect) {
                // Skip variant change and prevent rerender since variant is already selected
                selectVirtualVariant(virtualVariantToSelect, true, true);
              }
            }, 50);
          } else {
            // Variant doesn't have virtual variants - set quantity from variant's data-quantity (1, 3, 6 etc.)
            unselectAllVirtualVariants(false);
            const variantContainerForQty = e.target.closest('.input-label');
            if (variantContainerForQty) {
              variantContainerForQty.dataset.selectedVirtualIndex = '';
              const qty = parseInt(variantContainerForQty.dataset.quantity, 10);
              if (qty > 0) {
                setProductFormQuantity(qty);
              } else {
                setProductFormQuantity(1);
              }
            }
          }
        } else {
          // Check if it's a variant without virtual variants
          const normalVariantContainer = e.target.closest('.input-label:not(.phi--virtual-variant-hidden)');
          if (normalVariantContainer) {
            const hasVirtualVariants = normalVariantContainer.dataset.hasVirtualVariants === 'true';
            if (!hasVirtualVariants) {
              unselectAllVirtualVariants(false);
              const qty = parseInt(normalVariantContainer.dataset.quantity, 10);
              if (qty > 0) {
                setProductFormQuantity(qty);
              } else {
                setProductFormQuantity(1);
              }
            }
            // Update buy button price after variant change
            // setTimeout(updateBuyButtonPrice, 100);
          }
        }
      }
    });
    
    virtualVariantsInitialized = true;
  }
  
  // Function to apply selected styling to virtual variant
  function applySelectedStyling(virtualVariant) {
    virtualVariant.classList.add('phi--virtual-variant-selected');
    const radio = virtualVariant.querySelector('.custom-radio');
    if (radio) {
      radio.style.border = '4px solid #fff';
      radio.style.backgroundColor = '#85B0A2';
    }
  }
  
  // Function to check and auto-select virtual variants when variant changes
  function checkAndSelectVirtualVariants() {
    // Find the currently selected variant input
    const selectedInput = document.querySelector('.input-label input[type="radio"]:checked');
    
    if (selectedInput) {
      const variantContainer = selectedInput.closest('.input-label');
      const hasVirtualVariants = variantContainer && variantContainer.dataset.hasVirtualVariants === 'true';
      const variantId = variantContainer && variantContainer.dataset.variantId;
      
      if (hasVirtualVariants && variantId) {
        // Check if any virtual variant is already selected for this variant
        const selectedVirtualVariant = document.querySelector(`.phi--virtual-variant[data-variant-id="${variantId}"].phi--virtual-variant-selected`);
        
        if (!selectedVirtualVariant) {
          // Check if there's a stored virtual variant selection
          const variantContainer = document.querySelector(`.phi--virtual-variant-hidden[data-variant-id="${variantId}"]`);
          const storedVirtualIndex = variantContainer ? variantContainer.dataset.selectedVirtualIndex : null;
          
          let virtualVariantToSelect = null;
          
          if (storedVirtualIndex !== null && storedVirtualIndex !== '') {
            // Restore previously selected virtual variant
            virtualVariantToSelect = document.querySelector(`.phi--virtual-variant[data-variant-id="${variantId}"][data-virtual-index="${storedVirtualIndex}"]`);
          }
          
          // If no stored selection or stored variant not found, select first one
          if (!virtualVariantToSelect) {
            virtualVariantToSelect = document.querySelector(`.phi--virtual-variant[data-variant-id="${variantId}"]`);
          }
          
          if (virtualVariantToSelect) {
            // Skip variant change and prevent rerender since variant is already selected
            selectVirtualVariant(virtualVariantToSelect, true, true);
          }
        } else {
          // Apply styling if class is already there but styling is missing
          applySelectedStyling(selectedVirtualVariant);
        }
      } else {
        // Variant doesn't have virtual variants - set quantity from variant's data-quantity
        unselectAllVirtualVariants(false);
        if (variantContainer) {
          const qty = parseInt(variantContainer.dataset.quantity, 10);
          setProductFormQuantity(qty > 0 ? qty : 1);
        }
      }
    } else {
      // No variant selected, reset
      unselectAllVirtualVariants();
    }
    
    // Also check for virtual variants that already have the selected class (from Liquid)
    document.querySelectorAll('.phi--virtual-variant.phi--virtual-variant-selected').forEach(vv => {
      applySelectedStyling(vv);
      const quantity = parseInt(vv.dataset.quantity) || 1;
      setProductFormQuantity(quantity);
    });
  }
  
  // Initialize virtual variants when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initVirtualVariants();
      setTimeout(function() {
        checkAndSelectVirtualVariants();
        // updateBuyButtonPrice();
      }, 300);
    });
  } else {
    initVirtualVariants();
    setTimeout(function() {
      checkAndSelectVirtualVariants();
      // updateBuyButtonPrice();
    }, 300);
  }
  
  // Listen to variant changes
  if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
    subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, function() {
      setTimeout(function() {
        checkAndSelectVirtualVariants();
        // updateBuyButtonPrice();
      }, 300);
    });
    
    subscribe(window.PUB_SUB_EVENTS.variantChange, function() {
      setTimeout(function() {
        checkAndSelectVirtualVariants();
        // updateBuyButtonPrice();
      }, 300);
    });
  }
  
  // Also listen for DOM updates to restore virtual variant selection after rerender
  const variantObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        // Check if virtual variants were added (rerender happened)
        const hasVirtualVariants = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('phi--virtual-variant') ||
            node.querySelector?.('.phi--virtual-variant')
          )
        );
        
        if (hasVirtualVariants) {
          // Wait a bit for DOM to settle, then restore selection
          setTimeout(function() {
            checkAndSelectVirtualVariants();
          }, 100);
        }
      }
    });
  });
  
  // Observe variant-selects container for changes
  const variantSelectsContainer = document.querySelector('variant-selects');
  if (variantSelectsContainer) {
    variantObserver.observe(variantSelectsContainer, { childList: true, subtree: true });
  }




  document.addEventListener('DOMContentLoaded', function () {
    const variants = document.querySelectorAll('variant-selects .pi-variant__option');
  
    variants.forEach(variant => {
      variant.addEventListener('click', function () {
        
        // get price from inside the clicked variant
        const priceEl = this.querySelector('.pi-variant__price .glc-money');
        const price = priceEl ? priceEl.textContent.trim() : null;
  console.log(price);
        // update button
        const target = document.querySelector('.buybtn-custom-price');
        console.log(target);
        if (target && price) {
          target.textContent = price;
        }
      });
    });
  });

  // Handle selling plan option clicks to update quantity
  let sellingPlanOptionsInitialized = false;
  
  function updateQuantityFromSellingPlan(sellingPlanOption, inputElement) {
    // Get quantity from data-quantity attribute (check both container and input)
    let quantity = parseInt(sellingPlanOption.dataset.quantity) || 1;
    
    // Also check if the input element has data-quantity
    if (inputElement && inputElement.dataset.quantity) {
      quantity = parseInt(inputElement.dataset.quantity) || quantity;
    }
    
    // Find quantity input - try multiple selectors
    let quantityInput = null;
    const qtyBuyWrapper = document.querySelector('.qty-buy-main-wrapper');
    if (qtyBuyWrapper) {
      quantityInput = qtyBuyWrapper.querySelector('.quantity__input');
    }
    
    // Fallback: try to find quantity input in product form
    if (!quantityInput) {
      const productForm = document.querySelector('.product-form form, form[action*="/cart/add"]');
      if (productForm) {
        quantityInput = productForm.querySelector('input[name="quantity"], .quantity__input, input[type="number"][name*="quantity"]');
      }
    }
    
    // Another fallback: search by class
    if (!quantityInput) {
      quantityInput = document.querySelector('.quantity__input');
    }
    
    if (quantityInput && quantity > 0) {
      quantityInput.value = quantity;
      
      // Trigger multiple events to ensure all listeners are notified
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      
      // Also try setting value directly and triggering native events
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
      nativeInputValueSetter.call(quantityInput, quantity);
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  function initSellingPlanOptions() {
    if (sellingPlanOptionsInitialized) return;
    sellingPlanOptionsInitialized = true;
    
    // Use event delegation to handle clicks on selling plan options
    document.addEventListener('click', function(e) {
      // Check if click is on selling plan option or its child elements
      const sellingPlanOption = e.target.closest('.pi-selling-plan-option');
      if (sellingPlanOption) {
        // Find the input element within the selling plan option
        const inputElement = sellingPlanOption.querySelector('input[type="radio"]');
        updateQuantityFromSellingPlan(sellingPlanOption, inputElement);
      }
    });
    
    // Also listen for change events on the radio inputs directly
    document.addEventListener('change', function(e) {
      if (e.target.type === 'radio' && e.target.closest('.pi-selling-plan-option')) {
        const sellingPlanOption = e.target.closest('.pi-selling-plan-option');
        if (sellingPlanOption && e.target.checked) {
          updateQuantityFromSellingPlan(sellingPlanOption, e.target);
        }
      }
    });
  }

  // Initialize selling plan options when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSellingPlanOptions);
  } else {
    initSellingPlanOptions();
  }